import { render, staticRenderFns } from "./BlackBoard.vue?vue&type=template&id=043bb93c&scoped=true&"
import script from "./BlackBoard.vue?vue&type=script&lang=js&"
export * from "./BlackBoard.vue?vue&type=script&lang=js&"
import style0 from "./BlackBoard.vue?vue&type=style&index=0&id=043bb93c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043bb93c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VContainer,VLazy})
